(function () {
    'use strict';

    angular.module("imApp").factory("timeSheetsStatusService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 1396,
                    parameters: parms || {}
                });
            },
            listStatuses: function (parms) {
                return $ihttp.post({
                    method: 276,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
